const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.citycourier.org/api/v1';

interface BackendResponse<T> {
    success: boolean;
    data: T;
    message: string;
}

export interface SwitchBranchResponse {
    branch_id: number;
    branch_name: string;
}

// Helper function to get auth token
const getAuthToken = (): string | null => {
    return localStorage.getItem('token');
};

// Helper function to handle API errors
const handleApiError = async (response: Response): Promise<never> => {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
};

export const adminApi = {
    // Run Update Pricing (queues customer ledger update)
    runUpdatePricing: async (): Promise<string> => {
        const token = getAuthToken();
        if (!token) throw new Error('No authentication token');

        const response = await fetch(`${API_BASE_URL}/admin/update-pricing`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            await handleApiError(response);
        }

        const data: BackendResponse<[]> = await response.json();
        return data.message;
    },

    // Run Update Monthly Invoices (queues monthly invoice generation)
    runUpdateMonthlyInvoices: async (): Promise<string> => {
        const token = getAuthToken();
        if (!token) throw new Error('No authentication token');

        const response = await fetch(`${API_BASE_URL}/admin/update-monthly-invoices`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            await handleApiError(response);
        }

        const data: BackendResponse<[]> = await response.json();
        return data.message;
    },

    // Run Update Rider PINs (queues rider PIN regeneration)
    runUpdateRiderPins: async (): Promise<string> => {
        const token = getAuthToken();
        if (!token) throw new Error('No authentication token');

        const response = await fetch(`${API_BASE_URL}/admin/update-rider-pins`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            await handleApiError(response);
        }

        const data: BackendResponse<[]> = await response.json();
        return data.message;
    },

    // Switch Branch (updates authenticated user's branch)
    switchBranch: async (branchId: number): Promise<SwitchBranchResponse> => {
        const token = getAuthToken();
        if (!token) throw new Error('No authentication token');

        const response = await fetch(`${API_BASE_URL}/admin/switch-branch`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ branch_id: branchId }),
        });

        if (!response.ok) {
            await handleApiError(response);
        }

        const data: BackendResponse<SwitchBranchResponse> = await response.json();
        return data.data;
    },
};
